module.exports = __webpack_public_path__ + "static/img/02.63f4c636.gif";